import {Component, Input, OnInit} from '@angular/core';
import {ProfileService} from './services/profile.service';
import {ProfileModel} from '../shared/models/profile.model';
import { MatDialog } from '@angular/material/dialog';
import {AddProfileComponent} from './components/add-profile/add-profile.component';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {AuthService} from '../shared/service/auth.service';
import {AdminRolesEnum} from '../shared/enums/admin-roles.enum';
import {LoadingService} from '../shared/service/loading.service';
import { HierarchyService } from '../shared/service/hierarchy.service';
import { finalize } from 'rxjs/operators';
import { FdFieldConfigs } from '../shared/fd-form-components/fd-form-components.module';
import { FdSelectConfig } from '../shared/fd-form-components/fd-select/fd-select.component';

const sortByDescription = (a: any, b: any) =>
  String(a?.description ?? '').localeCompare(String(b?.description ?? ''));

@Component(
  {
    selector: 'app-profiles',
    templateUrl: './profiles.component.html',
    styleUrls: ['./profiles.component.scss'],
    standalone: false
}
)
export class ProfilesComponent implements OnInit {

  @Input() profiles: ProfileModel[];

  fields: FdFieldConfigs;

  constructor(private dialog: MatDialog,
              private formBuilder: UntypedFormBuilder,
              private authService: AuthService,
              private profileService: ProfileService,
              private loadingService: LoadingService,
              private sharedService: HierarchyService) {}

  formGroup: UntypedFormGroup;

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({});
    this.startForms();
  }

  getAllProfilesInstitutionServiceContract() {
    if(!this.formGroup.value.serviceContract) {
      return;
    }
    this.loadingService.show();
    this.profileService.getProfilesByInstitutionAndServiceContract(this.formGroup.value.institutionNumber, this.formGroup.value.serviceContract)
    .pipe(finalize(() => this.loadingService.hide()))
    .subscribe(p => {
      this.orderProfile(p);
      this.profiles = p;
    });
  }

  orderProfile(profiles: ProfileModel[]) {
    for(let prof of profiles) {
      prof.roles.sort(sortByDescription);
      // Ordernar perfis por descricao
    }
  }

  get hasWriteAccess() {
    return this.authService.isUserInRoles([AdminRolesEnum.PROFILE_WRITE]);
  }

  addProfile() {
    const dialogRef = this.dialog.open(AddProfileComponent, {
      width: '40%',
      height: '85%',
      disableClose: false,
      data: {
        institutionsItems: (this.fields.institutionNumber as FdSelectConfig).items
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      setTimeout(() => {
        this.getAllProfilesInstitutionServiceContract()
      }, 200);
    });
  }

  getInstitutionList(): void {
    this.loadingService.show();

    this.sharedService.institution()
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe(list => {
        if (list != null) {
          (this.fields.institutionNumber as FdSelectConfig).items = [];
          (this.fields.institutionNumber as FdSelectConfig).items.push({ label: 'Todos', value: '' });
          (this.fields.institutionNumber as FdSelectConfig).items.push(...list);
        }
      });
  }

  getServiceContract(institutionNumber: string): void {

    if (!institutionNumber) {
      institutionNumber = this.formGroup.value.institutionNumber;
    }
    this.loadingService.show();
    if (institutionNumber) {
      this.sharedService.serviceContractByInstitution(institutionNumber)
        .pipe(finalize(() => this.loadingService.hide()))
        .subscribe(data => {
          if (data) {
            (this.fields.serviceContract as FdSelectConfig).items = [];
            (this.fields.serviceContract as FdSelectConfig).items.push({ label: 'Todos', value: '' });
            (this.fields.serviceContract as FdSelectConfig).items.push(...data);
          }
        });
    }
  }

  selectedInstitution(): void {
    this.formGroup.controls.serviceContract.setValue(null);
    this.getServiceContract(this.formGroup.value.institutionNumber);
  }

  startForms(): void {

    this.formGroup = this.formBuilder.group({
      institutionNumber: [''],
      serviceContract: ['']
    });

    this.fields = {
      institutionNumber: {
        label: 'Nº Instituição',
        items: [],
        controlName: 'institutionNumber',
        panelWidth: '320px'
      },
      serviceContract: {
        label: 'Service Contract',
        items: [],
        controlName: 'serviceContract',
        panelWidth: '320px'
      }
    };

  }

}
